import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CareProvidersPage = lazy(() => import('../pages/care-providers/page'));
const ConceptPage = lazy(() => import('../pages/concept/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const IndividualPage = lazy(() => import('../pages/individual/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news-detail/page'));
const DayoriPage = lazy(() => import('../pages/dayori/page'));
const DayoriDetailPage = lazy(() => import('../pages/dayori/detail/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const CaseDetailPage = lazy(() => import('../pages/cases/detail/page'));
const CareGuideIndexPage = lazy(() => import('../pages/care-guide/page'));
const CareGuideStagesPage = lazy(() => import('../pages/care-guide/stages/page'));
const CareGuidePlanningPage = lazy(() => import('../pages/care-guide/planning/page'));
const CareGuideUpdatesPage = lazy(() => import('../pages/care-guide/updates/page'));
const CareGuideItemPage = lazy(() => import('../pages/care-guide/item/page'));
const RecruitPage = lazy(() => import('../pages/recruit/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/care-providers',
    element: <CareProvidersPage />,
  },
  {
    path: '/concept',
    element: <ConceptPage />,
  },
  {
    path: '/business',
    element: <BusinessPage />,
  },
  {
    path: '/individual',
    element: <IndividualPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/dayori',
    element: <DayoriPage />,
  },
  {
    path: '/dayori/:id',
    element: <DayoriDetailPage />,
  },
  {
    path: '/cases',
    element: <CasesPage />,
  },
  {
    path: '/cases/:id',
    element: <CaseDetailPage />,
  },
  {
    path: '/care-guide',
    element: <CareGuideIndexPage />,
  },
  {
    path: '/care-guide/stages',
    element: <CareGuideStagesPage />,
  },
  {
    path: '/care-guide/planning',
    element: <CareGuidePlanningPage />,
  },
  {
    path: '/care-guide/updates',
    element: <CareGuideUpdatesPage />,
  },
  {
    path: '/care-guide/:slug',
    element: <CareGuideItemPage />,
  },
  {
    path: '/recruit',
    element: <RecruitPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
